import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';

import CheckboxEmptyIcon from 'assets/img/icons/CheckboxEmptyIcon';
import CheckboxFilledIcon from 'assets/img/icons/CheckboxFilledIcon';
import TooltipIcon from 'pages/PlaygroundV2Page/components/TooltipIcon';
import ClearAllCheckbox from './components/ClearAllCheckbox';

import { useAppSelector } from 'core/store/hooks';
import { searchEngines } from 'pages/PlaygroundV2Page/helpers';
import { DARKER_GREY } from 'utils/theme';

const SearchEngineFilter = ({ localFilters, setLocalFilters }) => {
  const selectedSearchEngines = useAppSelector(
    (state) => state.sourceFilterV2.selectedSearchEngines
  );
  const claims = useAppSelector((state) => state.claimsV2.claims);

  const claimsSearchEngines = claims.flatMap((claim) =>
    claim.evidence?.map((e) => e.searchEngine ?? '')
  );

  const toggleSearchEngine = (searchEngine: string) => {
    setLocalFilters((prev) => ({
      ...prev,
      searchEngines: prev.searchEngines?.includes(searchEngine)
        ? prev.searchEngines.filter((searchEngineItem) => searchEngineItem !== searchEngine)
        : [...prev.searchEngines, searchEngine],
    }));
  };

  useEffect(() => {
    setLocalFilters((prev) => ({
      ...prev,
      searchEngines: selectedSearchEngines,
    }));
  }, [selectedSearchEngines, setLocalFilters]);

  return (
    <Stack direction="column">
      {searchEngines.map(({ name, label, tooltip }, index) => {
        const searchEnginesLength = claimsSearchEngines.filter((e) => e === name).length;

        return (
          <FormControlLabel
            key={index}
            checked={localFilters.searchEngines?.includes(name)}
            onChange={() => toggleSearchEngine(name)}
            control={
              <Checkbox
                sx={{ py: '4px', px: 1 }}
                icon={<CheckboxEmptyIcon />}
                checkedIcon={<CheckboxFilledIcon />}
              />
            }
            label={
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="subtitle1" color={DARKER_GREY}>
                  {label ?? name}
                </Typography>

                {searchEnginesLength > 0 && (
                  <Typography variant="subtitle1" color={DARKER_GREY}>
                    ({searchEnginesLength})
                  </Typography>
                )}

                {tooltip && <TooltipIcon tooltip={tooltip} />}
              </Stack>
            }
          />
        );
      })}

      <ClearAllCheckbox selectedSearchEngines={localFilters.searchEngines} />
    </Stack>
  );
};

export default SearchEngineFilter;
